import request from "@/core/request"
const findTenderBulletinType = (data) => {
    return request.request({
        url: '/sino/api/cms/findTenderBulletinType',
        method: 'post',
        data
    })
}
const findSortType = (data) => {
    return request.request({
        url: '/sino/api/cms/findSortType',
        method: 'post',
        data
    })
}
const findTenderProjectType = (data) => {
    return request.request({
        url: '/sino/api/cms/findTenderProjectType',
        method: 'post',
        data
    })
}
const findHomeNumber = () => {
    return request.request({
        url: '/sino/api/cms/findHomeNumber',
        method: 'post'
    })
}
const pageFindTenderBulletin = (params) => {
    return request.request({
        url: '/sino/api/cms/pageFindTenderBulletin',
        method: 'post',
        params: {
            ...params
        }
    })
}
const listFindTenderBulletin = (params) => {
    return request.request({
        url: '/sino/api/cms/listFindTenderBulletin',
        method: 'post',
        params: {
            ...params
        }
    })
}
const listFindTenderBulletinBidOpening = () => {
    return request.request({
        url: '/sino/api/cms/listFindTenderBulletinBidOpening',
        method: 'post'
    })
}
const listFindTenderBulletinPublishing = () => {
    return request.request({
        url: '/sino/api/cms/listFindTenderBulletinPublishing',
        method: 'post'
    })
}
const listFindRecruitBulletin = (params) => {
    return request.request({
        url: '/sino/api/cms/listFindRecruitBulletin',
        method: 'post',
        params: {
            ...params
        }
    })
}
const listpageFindRecruitBulletin = (params) => {
    return request.request({
        url: '/sino/api/cms/pageFindRecruitBulletin',
        method: 'post',
        params: {
            ...params
        }
    })
}
export {
    findTenderBulletinType,
    listpageFindRecruitBulletin,
    findSortType,
    findTenderProjectType,
    findHomeNumber,
    pageFindTenderBulletin,
    listFindTenderBulletin,
    listFindTenderBulletinBidOpening,
    listFindTenderBulletinPublishing,
    listFindRecruitBulletin
}